import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <h3 className="font-heading text-3xl md:text-4xl font-bold mb-6">
                Itaobuy Spreadsheet<br />Italia
              </h3>
              <p className="text-background-50/70 text-sm leading-relaxed max-w-md">
                {t('footer.trust')}
              </p>
              <div className="flex gap-4 mt-6">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50 hover:text-primary-500 transition-all cursor-pointer" aria-label="Facebook">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50 hover:text-primary-500 transition-all cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50 hover:text-primary-500 transition-all cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50 hover:text-primary-500 transition-all cursor-pointer" aria-label="Pinterest">
                  <i className="ri-pinterest-fill"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/50 mb-5">
                Link Rapidi
              </h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                  Home
                </Link>
                <Link to="/guida-itaobuy-sheet-2026" className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                  Guida Completa
                </Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                  itaobuy sheet
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                  buy it now
                </a>
              </div>
            </div>

            <div className="md:col-span-4">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/50 mb-5">
                Categorie
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {categories.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/50">
              {t('footer.copyright')}
            </p>
            <div className="flex gap-6">
              <Link to="/" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/guida-itaobuy-sheet-2026" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
                Guida
              </Link>
              <a href="#faq" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
                FAQ
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}